<script lang="ts">
    
    import { Badge, Button, Icon, Modal, ModalBody, ModalHeader } from "sveltestrap";
    import type { FormMember } from "../../Model/FormMember";
    import type { ReadableStore } from "../../Model/ReadableStore";
    import { instancesService } from "../../Services";
    import SignForm from "../SignForm.svelte";
    import UserName from "../UserName.svelte";
    import Watch from "../Watch.svelte";

    export let member: FormMember;

    let openSignModal = false;
    let isSigned: ReadableStore<boolean>;
    let partner: boolean = false;

    $: setupMember(member);

    function setupMember(member: FormMember): void {
        isSigned = member.isSignedReadable;
        partner = !!member.buddyId;
    }

    function toggleSignModal(): void {
        openSignModal = !openSignModal;
    }

    function onSigned(): void {
        openSignModal = false;
    }

    async function onRemoveSign(): Promise<void> {
        if (!confirm('¿Seguro que desea eliminar la firma de este miembro?')) {
            return;
        }
        try {
            await instancesService.unsingInstance(member.instance.id, member.userId);
            member.setUnsigned();
        } catch (error) {
            console.log(error);
        }
    }

</script>

<div class="flex-view">
    <div>
        <div>
            <Icon name={member.isOwner ? "person-circle" : "person-fill"} />
            
            {#if member.isOwner}
                <span class="fw-bold"><UserName id={member.userId} /></span>
            {:else}
                <UserName id={member.userId} />
            {/if}
        </div>
    
        {#if partner}
            <Badge pill color="warning">
                <!-- <span>BuddyPartner: </span> -->
                <Icon name="shield-lock-fill" />
                <UserName id={member.buddyId} />
            </Badge>
        {/if}
    </div>
    
    <div class="float-end">
    
        <Watch store={[member.instance.isFinishedReadable, member.isSignedReadable]} let:value={[isFinished, isSigned]}>
            {#if isFinished || isSigned}
                <Icon name="patch-check" />
                {#if !isFinished}
                <Button type="button" color="danger" size="sm" on:click={onRemoveSign}>
                    <Icon name="x" />
                </Button>
                {/if}
            {:else}
                <Button type="button" color="primary" size="sm" on:click={toggleSignModal}>
                    <Icon name="patch-check" /> Firmar
                </Button>
            {/if}
        </Watch>
    </div>
</div>


<Modal isOpen={openSignModal} toggle={toggleSignModal}>
    <ModalHeader toggle={toggleSignModal}>Firmar</ModalHeader>
    <ModalBody>
        <p>Firma de <span class="fw-bold"><UserName id={member.userId} /></span></p>
        <SignForm {member} on:signed={onSigned} />
    </ModalBody>
</Modal>


<style lang="scss">

    .flex-view{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

</style>